import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import {
  UtensilsCrossed, HardHat, ShoppingBag, Scissors, Dumbbell, Sparkles, ArrowRight
} from 'lucide-react';
import { INDUSTRIES } from '../data/industriesData';
import './IndustryPage.css';

const ICONS = { UtensilsCrossed, HardHat, ShoppingBag, Scissors, Dumbbell, Sparkles };
const EASE = [0.22, 0.61, 0.36, 1];

export default function IndustriesIndex() {
  const reduce = useReducedMotion();
  const rise = (d = 0) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, amount: 0.2 },
          transition: { duration: 0.6, delay: d, ease: EASE }
        };

  return (
    <main className="ind-page">
      {/* HERO */}
      <section className="ind-hero">
        <div className="ind-wrap">
          <motion.span className="ind-eyebrow" {...rise(0)}>One platform for every local business</motion.span>
          <motion.h1 className="ind-h1" {...rise(0.06)}>
            Built to grow <span className="ind-gold">your business</span>.
          </motion.h1>
          <motion.p className="ind-sub" {...rise(0.12)}>
            Restaurants, contractors, online stores, and more. One platform that flexes to fit how
            your business actually works. That is what makes us Versatile.
          </motion.p>
        </div>
      </section>

      {/* GRID */}
      <section className="ind-section ind-section-tint">
        <div className="ind-wrap">
          <div className="indx-grid">
            {INDUSTRIES.map((ind, i) => {
              const Icon = ICONS[ind.icon] || Sparkles;
              return (
                <motion.div key={ind.slug} {...rise((i % 3) * 0.06)}>
                  <Link to={`/industries/${ind.slug}`} className="indx-card">
                    <span className="indx-card-ic"><Icon size={24} strokeWidth={2} /></span>
                    <span className="indx-card-name">{ind.name}</span>
                    <span className="indx-card-desc">{ind.blurb}</span>
                    <span className="indx-card-go">See how it works <ArrowRight size={15} strokeWidth={2.4} /></span>
                  </Link>
                </motion.div>
              );
            })}

            {/* "& more" card */}
            <motion.div {...rise((INDUSTRIES.length % 3) * 0.06)}>
              <Link to="/plans" className="indx-card">
                <span className="indx-card-ic"><Sparkles size={24} strokeWidth={2} /></span>
                <span className="indx-card-name">Something else?</span>
                <span className="indx-card-desc">
                  If you run a local business, Versa Launch adapts to it. Tell us what you do and we
                  will build around it.
                </span>
                <span className="indx-card-go">Get started <ArrowRight size={15} strokeWidth={2.4} /></span>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="ind-section ind-final">
        <div className="ind-wrap">
          <motion.h2 className="ind-final-title" {...rise(0)}>Ready to grow your business?</motion.h2>
          <motion.p className="ind-final-text" {...rise(0.06)}>
            Get a platform built around your business, your customers, and your local market.
          </motion.p>
          <motion.div className="ind-cta-row" {...rise(0.12)}>
            <Link to="/plans" className="ind-btn ind-btn-onfill">
              Get started <ArrowRight size={17} strokeWidth={2.4} />
            </Link>
            <Link to="/book" className="ind-btn ind-btn-onfill-ghost">Book a call</Link>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
